import React, { useState } from 'react';

const faqs = [
  {
    question: 'What is Infor OS and what does it include?',
    answer:
      'Infor OS (Operating Service) is Infor\'s cloud-native platform that provides a unified foundation for all Infor applications. It includes Infor ION for integration and workflow automation, Infor API Gateway for secure API management, Infor Document Management (IDM), Infor Ming.le for collaboration and digital workspaces, Infor Data Lake for centralized data storage, Infor Birst Analytics for business intelligence, Infor Coleman AI for AI-driven insights, and Infor Process Intelligence for process monitoring and optimization.',
  },
  {
    question: 'What integration capabilities does Infor OS provide?',
    answer:
      'Infor OS provides comprehensive integration capabilities through Infor ION, API Gateway, and flexible integration tools. It supports integration with Infor applications (LN, M3, CSI, WMS, CRM), third-party applications, legacy systems, and cloud services. Integration options include Business Object Documents (BODs), REST and SOAP APIs, event-driven architecture, and pre-built connectors. This ensures seamless data flow and process synchronization across your entire enterprise ecosystem.',
  },
  {
    question: 'How does Infor OS support workflow automation?',
    answer:
      'Infor OS provides powerful workflow automation capabilities through its built-in workflow engine. You can design and implement business workflows, approval processes, event-driven automation, document routing, and business process orchestration. This helps automate routine tasks, enforce business rules, reduce manual effort, and provide real-time visibility into process status, significantly improving operational efficiency.',
  },
  {
    question: 'Can you help with Infor OS implementation and deployment?',
    answer:
      'Yes. We provide end-to-end Infor OS implementation services including solution architecture planning, environment provisioning, platform configuration, user and security setup, integration configuration, and go-live support. Our methodology ensures a smooth deployment with proper governance, security controls, and user adoption strategies to maximize your platform investment.',
  },
  {
    question: 'Do you offer training and documentation for Infor OS?',
    answer:
      'Yes. We provide comprehensive training programs covering platform administration, user enablement, integration development, and workflow design. Our training includes role-based sessions, hands-on practice scenarios, user documentation, technical guides, and knowledge transfer to ensure your teams can effectively leverage Infor OS capabilities.',
  },
  {
    question: 'How do you handle Infor OS security and identity management?',
    answer:
      'We implement robust security and identity management for Infor OS including Single Sign-On (SSO), identity and access management, role-based security controls, user provisioning, and security auditing. Our approach ensures your platform meets security compliance requirements while providing appropriate access to users based on their roles and responsibilities.',
  },
  {
    question: 'What analytics and reporting capabilities does Infor OS offer?',
    answer:
      'Infor OS provides advanced analytics and reporting through Infor Birst Analytics, Infor Data Lake, and embedded analytics capabilities. This includes KPI dashboards, executive reporting, operational analytics, real-time business insights, and AI-driven predictive analytics. You can access interactive visualizations, trend analysis, and data-driven insights to support informed decision-making across your organization.',
  },
  {
    question: 'Can you support Infor OS upgrades and cloud migration?',
    answer:
      'Yes. We provide complete upgrade and cloud migration services for Infor OS including platform upgrades, environment modernization, performance optimization, and release management. Our team manages the entire process from assessment through deployment, ensuring minimal disruption while leveraging new features and cloud capabilities to drive continuous innovation.',
  },
  {
    question: 'What ongoing support and managed services do you offer for Infor OS?',
    answer:
      'We provide comprehensive ongoing support including 24/7 application support, incident management, performance monitoring, preventive maintenance, SLA-based support, and continuous improvements. Our managed services ensure your Infor OS environment remains stable, secure, optimized, and aligned with evolving business requirements.',
  },
  {
    question: 'How does Infor OS leverage AI and machine learning?',
    answer:
      'Infor OS leverages AI and machine learning through Infor Coleman AI, which provides AI-driven insights, automated recommendations, anomaly detection, and business outcome forecasting. It also includes intelligent document processing, natural language processing, and predictive analytics capabilities that help organizations automate decisions, improve accuracy, and gain competitive advantage through data-driven intelligence.',
  },
];

const InforOSFAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFaq = (index) => {
    setOpenIndex((currentIndex) => (currentIndex === index ? null : index));
  };

  return (
    <section className="px-4 py-16 sm:px-6 lg:px-8 lg:py-12 bg-[#ffffff]">
      <div className="mx-auto max-w-7xl">
        <h2 className="mb-12 text-center text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl md:text-4xl">
          Frequently Asked Questions
        </h2>

        <div className="mx-auto max-w-4xl space-y-4">
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;

            return (
              <div
                key={faq.question}
                className="overflow-hidden rounded-xl border transition-all duration-200"
                style={{
                  backgroundColor: '#FFFFFF',
                  borderColor: isOpen ? '#4B5563' : '#E2E8F0',
                  boxShadow: isOpen ? '0 4px 20px rgba(14, 165, 164, 0.1)' : 'none',
                }}
              >
                <button
                  type="button"
                  onClick={() => toggleFaq(index)}
                  className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left"
                  aria-expanded={isOpen}
                >
                  <span 
                    className="text-lg font-semibold transition-colors duration-200"
                    style={{ color: isOpen ? '#4B5563' : '#1A2634' }}
                  >
                    {faq.question}
                  </span>
                  <span 
                    className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-xl font-bold transition-colors duration-200"
                    style={{ 
                      backgroundColor: isOpen ? '#4B5563' : '#F1F5F9',
                      color: isOpen ? '#FFFFFF' : '#64748B'
                    }}
                  >
                    {isOpen ? '-' : '+'}
                  </span>
                </button>

                <div
                  className={`transition-all duration-300 ease-in-out ${
                    isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <p className="px-6 pb-6 text-base leading-7 text-gray-600">
                    {faq.answer}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default InforOSFAQ;